import React from 'react'
import { BrowserRouter as Router,Routes, Route,} from 'react-router-dom';
import HomePage from './Pages/HomePage';
import DetailPage from './Pages/DetailPage';
import AboutUs from './Pages/AboutUs';
import VoiceBasedMultilingualForm from './Components/VoiceBasedMultilingualForm';
import VoiceTextToTextImageToTextTranslation from './Components/VoiceTextToTextImageToTextTranslation';
import VoiceToTextAndSpeechToSpeech from './Components/VoiceToTextAndSpeechToSpeech';
import AiSummary from './Components/AiSummary';
import AiVideoGenerator from './Components/AiVideoGenerator';
import Branding from './Components/Branding';
import DictationTool from './Components/DictationTool';
import FaceCutout from './Components/FaceCutout';
import GovtofIndiaSchemesAndInitiatives from './Components/GovtofIndiaSchemesAndInitiatives';
import ImageBackgroundRemover from './Components/ImageBackgroundRemover';
import LegalGlossary from './Components/LegalGlossary';
import MannKiBat from './Components/MannKiBat';
import MeetingCapture from './Components/MeetingCapture';
import OnlineDocumentTranslationTool from './Components/OnlineDocumentTranslationTool';
import VideoTranslation from './Components/VideoTranslation';
import PassportPhotoMaker from './Components/PassportPhotoMaker';
import RemoveUnwantedObjects from './Components/RemoveUnwantedObjects';
import VideoBackgroundRemover from './Components/VideoBackgroundRemover';
import VideowithVoice from './Components/VideowithVoice';
import TexttoVideo from './Components/TexttoVideo';
import VirtualKeyboard from './Components/VirtualKeyboard';
import ScreenRecording from './Components/ScreenRecording';
import VideoRecording from './Components/VideoRecording';
import MultiCameraRecording from './Components/MultiCameraRecording';
import PhoneasWebcam from './Components/PhoneasWebcam';
import Teleprompter from './Components/Teleprompter';
import RemoveCameraBackground from './Components/RemoveCameraBackground';
import ThreeDAudio from './Components/ThreeDAudio';
import AutoPanner from './Components/AutoPanner';
import BassBooster from './Components/BassBooster';
import Equalizer from './Components/Equalizer';
import NoiseReducer from './Components/NoiseReducer';
import PitchShifter from './Components/PitchShifter';
import Reverb from './Components/Reverb';
import ReverseAudio from './Components/ReverseAudio';
import StereoPanner from './Components/StereoPanner';
import TempoChanger from './Components/TempoChanger';
import TrimmerCutter from './Components/TrimmerCutter';
import VocalRemover from './Components/VocalRemover';
import VolumeChanger from './Components/VolumeChanger';
import ImageEditor from './Components/Editor/ImageEditor';
import TirmOfUse from './Components/TirmOfUse';
import PrivacyPolicy from './Components/PrivacyPolicy';
import OutletRoute from './Components/OutletRoute';
import AIVideoAnalyzer from './Pages/AIVideoAnalyzer';
import UploadFile from './Components/UploadFile';
import AiDiscription from './Components/VideoCamera/AiDiscription';
import VideoRecorder from './Components/VideoRecorder.jsx';

function RoutingPage() {

  return (
    <>
    <Router>      
      {/* <Header/> */}
        <Routes>
            {/* Pages */}
            <Route path='/audio/' element={<OutletRoute/>}>
            <Route index element={<HomePage/>}/>
            <Route path='/audio/detailPage' element={<DetailPage/>}></Route>
            <Route path='/audio/aboutUs' element={<AboutUs/>}></Route>
            {/* Translation */}
            <Route path='/audio/onlineDocumentTranslationTool' element={<OnlineDocumentTranslationTool/>}></Route>
            <Route path='/audio/govtofIndiaSchemesAndInitiatives' element={<GovtofIndiaSchemesAndInitiatives/>}></Route>
            <Route path='/audio/mannKiBat' element={<MannKiBat/>}></Route>
            <Route path='/audio/voiceBasedMultilingualForm' element={<VoiceBasedMultilingualForm/>}></Route>
            <Route path='/audio/dictationTool' element={<DictationTool/>}></Route>  
            <Route path='/audio/legalGlossary' element={<LegalGlossary/>}></Route> 
            <Route path='/audio/videoTranslation' element={<VideoTranslation/>}></Route>
            {/* Voice */}
            {/* <Route path='/audio/VoiceToTextAndSpeechToSpeech' element={<VoiceToTextAndSpeechToSpeech/>}></Route>
            <Route path='/audio/VoiceTextToTextImageToTextTranslation' element={<VoiceTextToTextImageToTextTranslation/>}></Route> */}
            <Route path='/audio/ThreeDAudio' element={<ThreeDAudio/>}></Route>
            <Route path='/audio/Autopartner' element={<AutoPanner/>}></Route>
            <Route path='/audio/BassBooster' element={<BassBooster/>}></Route>
            <Route path='/audio/Equalizer' element={<Equalizer/>}></Route>
            <Route path='/audio/NoiseReducer' element={<NoiseReducer/>}></Route>  
            <Route path='/audio/PitchShifter' element={<PitchShifter/>}></Route>  
            <Route path='/audio/Reverb' element={<Reverb/>}></Route>  
            <Route path='/audio/reverseAudio' element={<ReverseAudio/>}></Route>  
            <Route path='/audio/stereoPanner' element={<StereoPanner/>}></Route>  
            <Route path='/audio/tempoChanger' element={<TempoChanger/>}></Route>  
            <Route path='/audio/trimmerCutter' element={<TrimmerCutter/>}></Route>  
            <Route path='/audio/vocalRemover' element={<VocalRemover/>}></Route>  
            <Route path='/audio/volumeChanger' element={<VolumeChanger/>}></Route>  
           {/* Video */}
           <Route path='/audio/videoBackgroundRemover' element={<VideoBackgroundRemover/>}></Route>
           <Route path='/audio/videowithVoice' element={<VideowithVoice/>}></Route>
           <Route path='/audio/texttoVideo' element={<TexttoVideo/>}></Route>
           <Route path='/audio/aiSummary' element={<AiSummary/>}></Route>
           <Route path='/audio/aiVideoGenerator' element={<AiVideoGenerator/>}></Route>
           <Route path='/audio/branding' element={<Branding/>}></Route>
           <Route path='/audio/AIVideoAnalyzer' element={<AIVideoAnalyzer/>}></Route>
           <Route path='/audio/UploadFile' element={<UploadFile/>}></Route>
           <Route path='/audio/AiDiscription' element={<AiDiscription/>}></Route>
           {/* <Route path='/audio/VideoRecording' element={<VideoRecorder/>}></Route> */}
         
           {/* Images */}
           <Route path='/audio/passportPhotoMaker' element={<PassportPhotoMaker/>}></Route>
           <Route path='/audio/faceCutout' element={<FaceCutout/>}></Route>
           <Route path='/audio/removeUnwantedObjects' element={<RemoveUnwantedObjects/>}></Route>
           <Route path='/audio/imageBackgroundRemover' element={<ImageBackgroundRemover/>}></Route>
           
          {/* Meeting*/}
            <Route path='/audio/virtualKeyboard' element={<VirtualKeyboard/>}></Route>
            <Route path='/audio/screenRecording' element={<ScreenRecording/>}></Route>
            <Route path='/audio/videoRecording' element={<VideoRecording/>}></Route>
            <Route path='/audio/meetingCapture' element={<MeetingCapture/>}></Route>
            <Route path='/audio/multiCameraRecording' element={<MultiCameraRecording/>}></Route>
            <Route path='/audio/phoneasWebcam' element={<PhoneasWebcam/>}></Route>
            <Route path='/audio/teleprompter' element={<Teleprompter/>}></Route>
            <Route path='/audio/removeCameraBackground' element={<RemoveCameraBackground/>}></Route>
            <Route path='/audio/tirmOfUse' element={<TirmOfUse/>}></Route>
            <Route path='/audio/privacyPolicy' element={<PrivacyPolicy/>}></Route>
            </Route>
        </Routes>
        
      {/* <Footer/> */}
      <Routes>
        <Route path='/audio/Editor/ImageEditor' element={<ImageEditor/>}></Route>
      </Routes>
    </Router>
    </>
  )
}

export default RoutingPage
